import { apiClient } from '../apiClient';
import {
  SubscriptionLookupResponseDto,
  WalletBalanceDto,
  PriceModelDto,
  UsageStatsDto,
  FailedUsageEventDto,
} from '@shared/contracts';

export const subscriptionsApi = {
  getMySubscription: (): Promise<SubscriptionLookupResponseDto> => {
    return apiClient.get<SubscriptionLookupResponseDto>('/subscriptions/me');
  },

  getMyBalance: (): Promise<WalletBalanceDto> => {
    return apiClient.get<WalletBalanceDto>('/subscriptions/balance');
  },

  getPlans: (): Promise<PriceModelDto[]> => {
    return apiClient.get<PriceModelDto[]>('/subscriptions/plans');
  },

  reportUsage: (priceId?: string, usage: number = 1): Promise<{ identifier: string; success: boolean }> => {
    return apiClient.post<{ identifier: string; success: boolean }>('/subscriptions/usage', { priceId, usage });
  },

  getStats: (interval: 'hourly' | 'daily' = 'daily'): Promise<UsageStatsDto[]> => {
    return apiClient.get<UsageStatsDto[]>('/subscriptions/stats', { params: { interval } });
  },

  getFailed: (limit: number = 20, offset: number = 0): Promise<FailedUsageEventDto[]> => {
    return apiClient.get<FailedUsageEventDto[]>('/subscriptions/failed', { params: { limit, offset } });
  },

  calculatePrice: (priceId: string, quantity: number = 1): Promise<any> => {
    return apiClient.get<any>('/subscriptions/calculate-price', { params: { priceId, quantity } });
  },
};
